import { RouteContextWrapper } from "@/components/custom/providers/routeContextWrapper";

export default function SettingsDevToolsPage() {
  return (
    <RouteContextWrapper
      resolvedParams={{ caseId: "default" }}
      resolvedSearchParams={{}}
      settingsView="dev-tools"
    />
  );
}
